import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDAlert } from '@facet-wealth/design';

const DolDisclaimerAlert = ({
  label, value,
}) => {
  return (
    <FDBox margin={300}>
      <FDAlert
        title={label}
        description={value}
        status="warning"
      />
    </FDBox>
  );
};

DolDisclaimerAlert.defaultProps = {
};

DolDisclaimerAlert.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default DolDisclaimerAlert;
